<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 権限（施設関係者グループ）

    .register-value.show-message-radios(v-if="0 < _value.length")
      .list-container.d-flex.flex-row.justify-content-center.align-items-center.flex-wrap
        .other-user-group-list.d-flex.flex-column
          .list-body
            .group(v-for="group in _value" :key="group.id").d-flex.flex-row
              b-form-checkbox(v-model="group.isTarget")
              span {{ group.name }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputPermissionOtherUserGroup extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  private value!: Array<PermissionOtherUserGroupModel>;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): Array<PermissionOtherUserGroupModel> {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: Array<PermissionOtherUserGroupModel>) {
    this.$emit("input", newValue);
    return;
  }
}

export interface PermissionOtherUserGroupModel {
  groupId: number;
  name: string;
  isTarget: boolean;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.other-user-group-list {
  width: 610px;
  max-height: 240px;

  // デフォルトフォントサイズを指定する
  font-size: 16px;
  // 外枠はここで描画させる
  border: solid 1px $form-border-color;

  .list-body {
    overflow-y: scroll;
    overflow-x: auto;
    .group {
      padding: 8px;
      border-bottom: solid 1px $border-lightgray;
    }
  }
}
</style>
